export const ActionTypes = {
    SET_NEW_USER:'SET_NEW_USER'
  };